import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import { useHeartbeat } from "@/lib/presence";

import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Account from "@/pages/Account";
import Owner from "@/pages/Owner";
import BillingSuccess from "@/pages/BillingSuccess";
import Chat from "@/pages/Chat";
import Live from "@/pages/Live";
import Messages from "@/pages/Messages";
import Profile from "@/pages/Profile";
import Shop from "@/pages/Shop";
import Giveaways from "@/pages/Giveaways";

function Heartbeater() {
    const { user } = useAuth();
    useHeartbeat(user);
    return null;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Heartbeater />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/pricing" element={<Pricing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/account" element={<Account />} />
                        <Route path="/owner" element={<Owner />} />
                        <Route path="/billing/success" element={<BillingSuccess />} />
                        <Route path="/chat" element={<Chat />} />
                        <Route path="/live" element={<Live />} />
                        <Route path="/messages" element={<Messages />} />
                        <Route path="/messages/:convId" element={<Messages />} />
                        <Route path="/u/:userId" element={<Profile />} />
                        <Route path="/shop" element={<Shop />} />
                        <Route path="/giveaways" element={<Giveaways />} />
                    </Routes>
                    <Toaster theme="dark" position="top-center" richColors closeButton />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
